var render = function render(){var _vm=this,_c=_vm._self._c;return _c('IconButton',{directives:[{name:"tooltip",rawName:"v-tooltip.left",value:(_vm.$t('CONVERSATION.SWITCH_VIEW_LAYOUT')),expression:"$t('CONVERSATION.SWITCH_VIEW_LAYOUT')",modifiers:{"left":true}}],attrs:{"color-scheme":"secondary","icon":"arrow-right-import"},on:{"click":_vm.toggle}})
}
var staticRenderFns = []

export { render, staticRenderFns }